import { AccountView } from '../account-view';
import { changePassword, ChangePasswordRequest } from '../../general/modules/newPassword/changePassword';
import { getUserSuid } from '../../general/modules/getUserSuid';
import { CurrentPage } from '../../pages/currentPage';
import { ResetEmailPasswordResponse } from '../../api/hub-responses/reset-email-password-response';

export enum ChangePasswordErrorCodes {
    PASSWORD_CONFIRMATION_FAILED = 1,
    VALIDATION_ERROR = 400
}

export async function handleChangePasswordSubmit(event: JQuery.SubmitEvent) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const password = <string>formData.get('password');
    const passwordConfirm = <string>formData.get('password_conf');
    if (password !== passwordConfirm) {
        AccountView.showChangepassError(ChangePasswordErrorCodes.PASSWORD_CONFIRMATION_FAILED);
        return;
    }

    changePassPreproc();
    AccountView.hideAccountLoadingState();
    AccountView.showAccountUIGroup(AccountView.uiGroups.CHANGE_PASS);
    const accountManagementForm = $('#account_management');
    const response: ResetEmailPasswordResponse = await changePassRequest(password);
    if (response.status === 1) {
        const changepass = $('#changepass');
        const changepassSuccess = $('#changepass_success_b');
        AccountView.hideAccountError();
        changepassSuccess.show();
        changepass.find('#input_placeholder,button').hide();
        $('.js-close-button', accountManagementForm).on('click', function changePassResetForm() {
            changepassSuccess.hide();
            changepass.find('#input_placeholder input').val('');
            changepass.find('#input_placeholder,button').show();
            $('.js-close-button', accountManagementForm).off('click', changePassResetForm);
        });
        setTimeout(() => {
            CurrentPage.reload();
        }, 2000);
    } else {
        AccountView.showChangepassError(response.error.code, response.error.message);
    }
}

async function changePassRequest(password: string) {
    const changePasswordRequest: ChangePasswordRequest = {
        suid: getUserSuid(false),
        locale: window.app.config.locale,
        password: password,
        token: window.app.config.user_auth_token
    };

    return changePassword(changePasswordRequest);
}

function changePassPreproc() {
    AccountView.hideAccountError();
    AccountView.showAccountLoadingState();
}
